import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { BaseApiService, ApiResponse } from './base-api.service';
import { Campaign } from '@core/models/campaign.model';
import { environment } from '@environments/environment';
import { CURRENCY_ISO, CurrencyIso } from '@core/utils/currency.utils';

export interface CampaignApiFilters {
    advertiserId?: number;
    type?: string;
    state?: string;
    startDate?: string;
    endDate?: string;
}

interface PaginatedResponse {
    page: number;
    data: any[];
}

@Injectable({
    providedIn: 'root',
})
export class CampaignApiService extends BaseApiService {
    /** `currency` is an ISO code: the API converts the amounts, the list keeps showing the symbol. */
    getCampaigns(grandCompteId: number, currency: CurrencyIso = CURRENCY_ISO.EUR): Observable<ApiResponse<{ page: number; data: Campaign[] }[]>> {
        const params = new HttpParams().set('currency', currency);
        return this.get<ApiResponse<PaginatedResponse[]>>(`/campaigns/?gc_id=${grandCompteId}`, params, {
            baseUrl: environment.ip_reporting,
        }).pipe(
            map((response) => {
                if (response.code === 200 && response.data) {
                    response.data = response.data.map((page) => ({
                        page: page.page,
                        data: page.data && Array.isArray(page.data) ? Campaign.fromApiResponseArray(page.data) : [],
                    }));
                }
                return response;
            }),
        );
    }
}
